export function setSurveys (state, surveys) {
  state.surveys = surveys;
}

export function setSurvey (state, survey){
  state.selectedSurvey = survey
}

export function surveysError(state, payload){
  state.error = true
  state.errorMessage = payload
  state.surveys = []
}